import { connect } from 'react-redux';
import { createSelector, createStructuredSelector } from 'reselect';
import { orderSelector } from 'selectors/order/orderSelector';
import OrderUtils from 'utils/Order';
import React from 'react';
import shippingGroupsEntriesSelector from 'selectors/order/orderDetails/shippingGroups/shippingGroupsEntries/shippingGroupsEntriesSelector';
import UserSubscriptionsSelector from 'selectors/user/userSubscriptions/userSubscriptionsSelector';
import LanguageLocaleUtils from 'utils/LanguageLocale';
import DeliveryOptionsUtils from 'utils/DeliveryOptions';
import Actions from 'Actions';
import SddCard from 'components/FrictionlessCheckout/SddSection/SddCard/SddCard';
import { SECTION_NAMES } from 'constants/frictionlessCheckout';
import SddSectionEN from 'components/FrictionlessCheckout/SddSection/locales/SddSection_en_US';
import SddSectionFR from 'components/FrictionlessCheckout/SddSection/locales/SddSection_fr_CA';
import { errorSelector } from 'viewModel/selectors/checkout/sdd/errorSelector.js';

const { userSubscriptionsSelector } = UserSubscriptionsSelector;
const { getLocalisedDataFromResource, getTextFromResource } = LanguageLocaleUtils;

const {
    SHIPPING_GROUPS: { SAME_DAY },
    isSDUOnlyOrder,
    hasSDUOnlyInSddBasket
} = OrderUtils;

const getText = getLocalisedDataFromResource(SddSectionEN, SddSectionFR);
const { isNDDNewDeliveryName } = DeliveryOptionsUtils;

const functions = {
    showContentModal: Actions.showContentModal
};

const withSddSectionProps = connect(
    createSelector(
        createStructuredSelector({
            sduTitle: getTextFromResource(getText, 'sameDayUnlimited'),
            nextDayDelivery: getTextFromResource(getText, 'nextDayDelivery'),
            fastDelivery: getTextFromResource(getText, 'fastDelivery')
        }),
        shippingGroupsEntriesSelector,
        errorSelector,
        orderSelector,
        userSubscriptionsSelector,
        ({ sduTitle, nextDayDelivery, fastDelivery }, shippingGroupsEntries, errorMessage, order, userSubscriptions) => {
            const sameDayShippingGroup = shippingGroupsEntries.find(group => group.shippingGroupType === SAME_DAY)?.shippingGroup || {};
            const error = errorMessage || order.scheduledAddrChangeMessage;
            const isSDUOrderOnly = isSDUOnlyOrder(order.orderDetails);
            const isSDUInSddBasketOnly = hasSDUOnlyInSddBasket(order.orderDetails);
            const sameDayDeliveryBasket = OrderUtils.getSameDayDeliveryBasket(order.orderDetails);
            const isSDUInBasket = sameDayDeliveryBasket.items?.filter(item => item.sku.type === 'SDU').length > 0;
            const isUserSDUMember = userSubscriptions[0]?.status?.startsWith('ACTIVE') ?? false;
            const subTitle = '';
            const deliveryInfo = '';
            const promiseDateInfo = {};
            const displaySDUDeliveryPrice = isSDUInBasket || isUserSDUMember;
            const isDeliveryWindowScheduled =
                sameDayShippingGroup.shippingMethod?.shippingMethodType?.includes('Schedule') ||
                sameDayShippingGroup.shippingMethod?.shippingMethodType?.includes('Planifier');
            const isNextDayDelivery = isDeliveryWindowScheduled
                ? sameDayShippingGroup?.sameDayDeliveryMessage?.includes('Tomorrow') ||
                  sameDayShippingGroup?.sameDayDeliveryMessage?.includes('Demain')
                : sameDayShippingGroup?.sameDayDeliveryLabel?.includes('tomorrow') || sameDayShippingGroup?.sameDayDeliveryLabel?.includes('demain');

            // Feature flag check: use Fast Delivery branding when KS enabled
            const baseTitle =
                isSDUOrderOnly || isSDUInSddBasketOnly ? sduTitle : isNextDayDelivery ? nextDayDelivery : sameDayShippingGroup?.sameDayTitle;

            const title = isNDDNewDeliveryName() && !isSDUOrderOnly && !isSDUInSddBasketOnly ? fastDelivery : baseTitle;
            const sectionLevelError = order.sectionErrors?.[SECTION_NAMES.SDD]?.length && order.sectionErrors?.[SECTION_NAMES.SDD];

            return {
                deliveryInfo,
                error,
                promiseDateInfo,
                subTitle,
                isSDUInBasket,
                title,
                isDeliveryVisible: !isSDUOrderOnly && !isSDUInSddBasketOnly,
                isUserSDUMember,
                displaySDUDeliveryPrice,
                isSDUOnlyOrder: isSDUOrderOnly || isSDUInSddBasketOnly,
                sectionLevelError
            };
        }
    ),
    functions
);

const SddCardWithProps = withSddSectionProps(SddCard);

export default SddCardWithProps;
